/**
 * Group
 */
export const Group = (function () {

  var init =  function () {   
        
       
  };
  /**
   * Formatters that are used in the group table
   */
  var formatters = {
    linkFormat: function(value, row){
      return `<a href='${window.location.pathname}/member/${row['mydexid']}'>${value}</a>`;
    },
    buttonFormatter: function(value, row){
      return `<buttons class="btn btn-primary" data-toggle="modal" data-target="#sendMessage"">Send Message</a>`;
    }
  };


  return {
    init: init,
    formatters : formatters
  }

}());


